// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gu9b","newExpiryDate":"styles_newExpiryDate__3r8yH","footer":"styles_footer__3sw-B"};